import { Col } from 'antd'
import React from 'react'

const LeftItems = () => {
    return (
        <Col className="gutter-row" xs={24} lg={5}>
            <ul className="nav flex-column nav-pills border border-1 border-light-dark h-100">
                <li className="nav-item m-0">
                    <a
                        className="nav-link radius-0 font-weight-bold active"
                        data-toggle="tab"
                        href="#tab_pane_1"
                    >
                        Store
                    </a>
                </li>

                <li className="nav-item m-0">
                    <a
                        className="nav-link radius-0 font-weight-bold"
                        data-toggle="tab"
                        href="#tab_pane_5"
                        tabIndex="-1"
                        aria-disabled="true"
                    >
                        Return & Exchange Settings
                    </a>
                </li>
                <li className="nav-item m-0">
                    <a
                        className="nav-link radius-0 font-weight-bold"
                        data-toggle="tab"
                        href="#tab_pane_7"
                        tabIndex="-1"
                        aria-disabled="true"
                    >
                        Cancellation Settings
                    </a>
                </li>
            </ul>
        </Col>
    )
}

export default LeftItems